<template>
  <v-container id="tarifas" tag="section">
    <base-v-component heading="Tarifas del Negocio " />
    <base-material-card
      color="indigo"
      icon="mdi-currency-eur"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="goAdd()">{{
          formTitle
        }}</v-btn>
        <v-spacer />
        <v-spacer></v-spacer>
        <v-btn color="success" @click="getTarifas()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="tarifas"
        :loading="loading"
        disable-pagination
      >
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <!-- <v-tooltip top v-if="item.activo">
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="cambiarActivo(item)"
                  :loading="loadingActivo"
                  class="px-2 ml-1"
                  color="green"
                  min-width="0"
                  v-on="on"
                  small
                >
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Desactivar</span>
            </v-tooltip>
            <v-tooltip top v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="cambiarActivo(item)"
                  v-on="on"
                  class="px-2 ml-1"
                  :loading="loadingActivo"
                  color="red"
                  min-width="0"
                  small
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Activar</span>
            </v-tooltip> -->
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="goEdit(item)"
                  class="px-2 ml-1"
                  color="success"
                  min-width="0"
                  v-on="on"
                  small
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-btn
              class="px-2 ml-1"
              color="red"
              min-width="0"
              small
              :loading="loadingEliminar"
              @click="deleteItem(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          {{ formTitle }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field v-model="tarifa.nombre" label="Nombre" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model="tarifa.descripcion" label="Descripción" />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn :loading="loadingSave" color="success" @click="save"
            >Guardar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: false,
      loadingSave: false,
      loadingActivo: false,
      loadingEliminar: false,
      headers: [
        {
          text: "Nombre",
          value: "nombre",
        },
        {
          text: "Descripción",
          value: "descripcion",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      dialog: false,
      tarifa: {
        id: null,
        descripcion: "",
        nombre: "",
      },
    };
  },
  watch: {
    dialog(v) {
      if (!v) {
        this.tarifa = {
          id: null,
          descripcion: "",
          nombre: "",
        };
      }
    },
  },
  computed: {
    formTitle() {
      return this.id ? "Editar Tarifa" : "Nueva Tarifa";
    },
    ...mapState({
      tarifas: (state) => state.productos.tarifas,
    }),
  },
  methods: {
    goAdd() {
      this.dialog = true;
    },
    goEdit(item) {
      this.dialog = true;
      this.tarifa = item;
    },
    deleteItem(item) {
      var confirm = false;
      this.$confirm("¿Desea eliminar la tarifa? Esta acción es irreversible?", {
        buttonTrueText: "Aceptar",
        buttonFalseText: "No",
        color: "warning",
        icon: "warning",
        width: 350,
      })
        .then((r) => {
          if (r) {
            confirm = true;
            this.loadingEliminar = true;
            return this.$store.dispatch("productos/eliminarTarifa", item);
          }
        })
        .then(() => {
          if (confirm) {
            this.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Tarifa eliminada",
            });
          }
        })
        .catch((e) => {
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "No se ha podido eliminar la tarifa " + e,
          });
        })
        .finally(() => {
          this.loadingEliminar = false;
          this.getTarifas();
        });
    },
    save() {
      this.loadingSave = true;
      this.$store
        .dispatch("productos/addTarifa", this.tarifa)
        .then((res) => {
          this.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Tarifa grabada con éxito",
          });
          this.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la tarifa",
          });
        })
        .finally(() => {
          this.loadingSave = false;
          return this.getTarifas();
        });
    },
    getTarifas() {
      this.loading = true;
      this.$store
        .dispatch("productos/getTarifas")
        .finally(() => (this.loading = false));
    },
  },
  mounted() {},
};
</script>

<style>
</style>